/* eslint-disable */
import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  ReferenceLine,
} from "recharts";
import "../../../../../styles/ComponentsStyles/Organizational/Management/Dashboard/LineChartGraph.style.css";
import PropTypes from "prop-types";

export default function LineChartComponent({
  data=[],
  customToolTip,
  lineColor = "#7BD7CD",
}) {
  const allValues = (data && data?.map(({ profit }) => profit)) || [];
  const maxValue = allValues.length > 0 ? Math.max(...allValues) : 0;
  const nearestValue = Math.ceil(maxValue / 10) * 10;

  const referenceLines = [];
  for (let i = 10000; i <= nearestValue; i += 10000) {
    referenceLines.push(
      <ReferenceLine key={i} y={i} stroke="#CFCFCF" strokeWidth={1} />
    );
  }
  console.log(data);

  return (
    data && (
      <div className="chart-container">
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={(data && data) || []}>
            <XAxis dataKey="name" stroke="#555" />
            <YAxis stroke="#555" />
            {customToolTip ? <Tooltip content={customToolTip} /> : <Tooltip />}
            <Line
              type="linear"
              dataKey="profit"
              stroke={lineColor}
              strokeWidth={2}
              name="Profit"
              dot={false}
            />
            {referenceLines}
          </LineChart>
        </ResponsiveContainer>
      </div>
    )
  );
}

LineChartComponent.propTypes = {
  data: PropTypes.object.isRequired,
  lineColor: PropTypes.string,
};
